import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { getAnswerHighlights, getData } from '../../utility.js';

let fullName = "";


export function getJobTypeScoreStrings(jobTypeScore) {
    let title = "Empfehlung: "
    let text = "Basierend darauf, wie du dein Arbeitsverhalten einschätzt, ";
    if (jobTypeScore < 0.35) {
        title += "Studium";
        text += "passt ein Studium am besten zu dir.";
    } else if (jobTypeScore < 0.65) {
        title += "Studium oder Ausbildung";
        text += "passen sowohl ein Studium als auch eine Ausbildung gut für dich.";
    } else {
        title += "Ausbildung";
        text += "passt eine Ausbildung am besten zu dir.";
    }
    return [title, text];
}


async function getGutachtenData() {
    const results = await getData('get-results/');
    const answerHighlights = await getAnswerHighlights();
    console.log(results);
    console.log(answerHighlights);

    let data = {};
    let temp;

    data['full_name'] = answerHighlights.name.name == '' ? answerHighlights.name.username : answerHighlights.name.name;
    fullName = data['full_name'];
    data['date'] = new Date().toLocaleDateString();

    // interessenhighlights: nr, name, score, examples: aussage 1,2,3
    data['interessenhighlights'] = [];
    Object.entries(answerHighlights.interessen_subcategories).forEach(([name, entry], i) => {
        console.log(entry);
        temp = {}
        temp['nr'] = i + 1;
        temp['name'] = name;
        temp['score'] = (entry.score * 100).toFixed(0);
        temp['highlights'] = entry.highlights;
        data['interessenhighlights'].push(temp);
    });
    // faehigkeitenhighlights: nr, name, score, examples: aussage 1,2,3
    data['faehigkeitenhighlights'] = []
    Object.entries(answerHighlights.faehigkeiten_subcategories).forEach(([name, entry], i) => {
        temp = {}
        temp['nr'] = i + 1;
        temp['name'] = name;
        temp['score'] = (entry.score * 100).toFixed(0);
        temp['highlights'] = entry.highlights;
        temp['description'] = entry.description;
        data['faehigkeitenhighlights'].push(temp)
    });
    // zielgruppenhighlights
    data['zielgruppenhighlights'] = answerHighlights.zielgruppen;
    // gegenstaendehighlights
    data['gegenstaendehighlights'] = answerHighlights.gegenstaende;

    // schulfaecherhighlights
    data['schulfaecherhighlights'] = answerHighlights.schulfaecher;
    // ortehighlights
    data['ortehighlights'] = answerHighlights.orte;
    
    // arbeitsverhaltenevaluationtitle, arbeitsverhaltenevaluationtext
    let jobTypeScoreStrings = getJobTypeScoreStrings(results.job_type_score);
    data['arbeitsverhaltenevaluationtitle'] = jobTypeScoreStrings[0];
    data['arbeitsverhaltenevaluationtext'] = jobTypeScoreStrings[1];
    data['arbeitsverhalten_studium_highlights'] = []
    Object.entries(answerHighlights.arbeitsverhalten_subcategories.studium).forEach(([name, entry], i) => {
        temp = {}
        temp['name'] = name;
        temp['highlights'] = entry.highlights;
        data['arbeitsverhalten_studium_highlights'].push(temp)
    });
    data['arbeitsverhalten_ausbildung_highlights'] = []
    Object.entries(answerHighlights.arbeitsverhalten_subcategories.ausbildung).forEach(([name, entry], i) => {
        temp = {}
        temp['name'] = name;
        temp['highlights'] = entry.highlights;
        data['arbeitsverhalten_ausbildung_highlights'].push(temp)
    });
    data['arbeitsverhalten_studium'] = data['arbeitsverhalten_studium_highlights'].length > 0
    data['arbeitsverhalten_ausbildung'] = data['arbeitsverhalten_ausbildung_highlights'].length > 0
 
    // ausbildungenonly
    data['ausbildungenonly'] = results.results_studium.length > 0 ? false : true;

    // studiengaenge: nr, name, score, hasschwerpunkte, schwerpunkte: name 1,2,3
    data['studiengaenge'] = [];
    results.results_studium.forEach(function (result, i) {
        temp = {};
        temp['nr'] = i + 1;
        temp['name'] = result.job;
        temp['alternatives'] = [result.alternative_job_title];
        temp['score'] = (result.score * 100).toFixed(0);
        temp['id'] = result.id;
        temp['has_steckbrief'] = result.steckbrief != {};
        
        if (temp['has_steckbrief']) {
            temp['description_title'] = Object.keys(result.steckbrief)[0];
            temp['description'] = Object.values(result.steckbrief)[0].join('\n');
            temp['contents'] = result.steckbrief["Inhalte des Studiums"];
            temp['perspective'] = result.steckbrief["Nach dem Studium"].join('\n');
            temp['weiterfuehrende_studienfaecher_text'] = result.steckbrief["weiterfuehrende_studienfaecher"]["text"];
            temp['weiterfuehrende_studienfaecher_list'] = result.steckbrief["weiterfuehrende_studienfaecher"]["list"];
            console
            temp['alternatives'] = result.steckbrief["studiengangsbezeichnungen"];
            if (result.alternative_job_title != "") {
                temp['alternatives'].push(result.alternative_job_title);
            }
            
        }

        temp['has_schwerpunkte'] = result.schwerpunkte.length > 0;
        temp['schwerpunkte'] = [];
        result.schwerpunkte.forEach(function (schwerpunkt) {
            temp['schwerpunkte'].push(schwerpunkt.job);
        });
        data['studiengaenge'].push(temp);
    });
    // ausbildungen: nr, name, score, hasschwerpunkte, schwerpunkte: name 1,2,3
    data['ausbildungen'] = []
    results.results_ausbildung.forEach(function (result, i) {
        temp = {};
        temp['nr'] = i + 1;
        temp['name'] = result.job;
        temp['has_alternatives'] = result.alternative_job_title != "";
        temp['alternatives'] = result.alternative_job_title;
        temp['score'] = (result.score * 100).toFixed(0);
        temp['id'] = result.id;
        temp['has_steckbrief'] = Object.keys(result.steckbrief).length > 0;
        
        if (temp['has_steckbrief']) {
            temp['description'] = result.steckbrief["Was macht man in diesem Beruf?"].join('\n');
            temp['employer'] = result.steckbrief["Wo arbeitet man?"];
            temp['ausbildungsinhalt'] = Object.values(result.steckbrief['ausbildungsinhalt'])[0];
            temp['anpassung'] = result.steckbrief["anpassung"];
            temp['aufstieg'] = result.steckbrief["aufstieg"];
        }
        
        temp['has_schwerpunkte'] = result.schwerpunkte.length > 0;
        temp['schwerpunkte'] = [];
        result.schwerpunkte.forEach(function (schwerpunkt) {
            temp['schwerpunkte'].push(schwerpunkt.job);
        });
        data['ausbildungen'].push(temp);
    });
    console.log(data);
    return data;
}

async function getGutachtenBlob() {
    const response = await fetch('/gutachten_template.docx');
    if (!response.ok) {
        throw new Error('Failed to load template file');
    }
    const content = await response.arrayBuffer();

    // var imageModule = getImageModule();

    const zip = new PizZip(content);
    const doc = new Docxtemplater(zip, {paragraphLoop: true, linebreaks: true}) //.attachModule(imageModule);

    let data = await getGutachtenData();
    // data['ability_image'] = "image.jpg";
    doc.render(data); // here the values are inserted into the word document
    
    const blob = doc.getZip().generate({
        type: 'blob',
        mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        compression: 'DEFLATE',
    });
    return blob;
}


export async function exportGutachtenAsWord() {
    const blob = await getGutachtenBlob();
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `Gutachten_${fullName}.docx`;
    link.click();
    URL.revokeObjectURL(link.href);
}

// export async function exportGutachtenAsPDF() {
//     const blob = getGutachtenBlob();
//     const formdata = new FormData('file', blob);
    
//     const response = await post('convert-to-pdf/', formdata);

//     if (!response.ok) {
//         throw new Error('Failed to convert file to PDF');
//     }

//     const pdfBlob = await response.blob();
//     const link = document.createElement('a');
//     link.href = URL.createObjectURL(pdfBlob);
//     link.download = 'gutachten.pdf';
//     link.click();

// }
